<div class="paginator" #paginator>
    <ng-container *ngFor="let _ of [].constructor(pagesRef?.nativeElement?.children?.length); let i = index">
        <span *ngIf="i === 0" data-active></span>
        <span *ngIf="i !== 0"></span>
    </ng-container>
</div>

